import React, { useState, useEffect } from 'react';

import '../../styles/jischeckbox.css';
import DynamicIcon from '../dynamicicon';

function JisCheckbox({
  label,
  value,
  onChange,
  name,
  required = false,
  errorMessage = 'This field is required.',
  size=30,
  disabled=false, back='fill'
}) {
  const [touched, setTouched] = useState(false);
  const isInvalid = required && touched && !value;

  const handleToggle = () => {
    if(disabled){
      onChange(false);
      return;
    }
    onChange(!value);
    if (!touched) setTouched(true);
  };

  useEffect(() => {
    if (!required) setTouched(false);
  }, [required]);

  return (
    <div className="jis-checkbox"  onClick={handleToggle}>
      <div className={`checkbox-icon ${isInvalid ? 'invalid' : ''}`}>
        {!value ? <DynamicIcon iname="square" size={size} /> : <DynamicIcon iname="square-check" size={size+5} />}
      </div>
      <div className="checkbox-label">{label}</div>
      {isInvalid && <div className="error-msg">{errorMessage}</div>}
    </div>
  );
}

export default JisCheckbox;
